module.exports = __webpack_public_path__ + "img/disease-pic2.74a13053.png";